import type { ReactElement } from "react";
import { useParams } from "react-router-dom";

import { ProductEditor } from "@/features/product-editor/ProductEditor";
import { useSellerEditorPort } from "@/features/seller-dashboard/editorPort";

export function ProductEditorPage(): ReactElement {
  const { id } = useParams<{ id: string }>();
  const port = useSellerEditorPort();
  return <ProductEditor port={port} routeId={id ?? null} />;
}

export default ProductEditorPage;
